const router = [
  {
    path: "/personalCenter",
    meta: {
      title: "用户中心",
    },
    component: (resolve) => require(["../views/personalCenter/index"], resolve),
    children: [
      {
        path: "/userCenter",
        meta: {
          title: "用户中心",
        },
        component: (resolve) =>
          require(["../views/userCenter/userCenter"], resolve),
      },
      {
        path: "/withdrawal",
        meta: {
          title: "提现",
        },
        component: (resolve) =>
          require(["../views/personalCenter/withdrawal"], resolve),
      },
      {
        path: "/order",
        meta: {
          title: "订单",
        },
        component: (resolve) => require(["../views/order/order"], resolve),
      },
      {
        path: "/voucher",
        meta: {
          title: "交易凭证",
        },
        component: (resolve) => require(["../views/order/voucher"], resolve),
      },
      {
        path: "/personalCenter/entryBid",
        meta: {
          title: "报名的竞价",
        },
        component: (resolve) =>
          require(["../views/personalCenter/entryBid"], resolve),
      },
      {
        path: "/personalCenter/entryHang",
        meta: {
          title: "报名的挂牌",
        },
        component: (resolve) =>
          require(["../views/personalCenter/entryHang"], resolve),
      },
      {
        path: "/personalCenter/article",
        meta: {
          title: "点赞的文章",
        },
        component: (resolve) =>
          require(["../views/personalCenter/article"], resolve),
      },
      {
        path: "/personalCenter/customerService",
        meta: {
          title: "专属客服",
        },
        component: (resolve) =>
          require(["../views/personalCenter/customerService"], resolve),
      },
      {
        path: "/personalCenter/account",
        meta: {
          title: "我的账户",
        },
        component: (resolve) =>
          require(["../views/personalCenter/account"], resolve),
      },

      {
        name: "userBankReplace",
        path: "/personalCenter/userBankReplace",
        meta: {
          title: "更换银行卡",
        },
        component: (resolve) =>
          require(["../views/personalCenter/userBankReplace"], resolve),
      },
      {
        path: "/personalCenter/rollOut",
        meta: {
          title: "转出",
        },
        component: (resolve) =>
          require(["../views/personalCenter/rollOut"], resolve),
      },
      {
        path: "/personalCenter/rollIn",
        meta: {
          title: "转入",
        },
        component: (resolve) =>
          require(["../views/personalCenter/rollIn"], resolve),
      },
      {
        path: "/personalCenter/tradeList",
        meta: {
          title: "我发布的交易",
        },
        component: (resolve) =>
          require(["../views/personalCenter/tradeList"], resolve),
      },
      {
        path: "/personalCenter/buyer",
        meta: {
          title: "买入",
        },
        component: (resolve) =>
          require(["../views/personalCenter/buyer"], resolve),
      },
      {
        path: "/personalCenter/seller",
        meta: {
          title: "卖出",
        },
        component: (resolve) =>
          require(["../views/personalCenter/seller"], resolve),
      },
      {
        path: "/personalCenter/stashEnter",
        meta: {
          title: "仓单录入",
        },
        component: (resolve) =>
          require(["../views/personalCenter/stashEnter"], resolve),
      },
      {
        path: "/personalCenter/stashOrigin",
        meta: {
          title: "原始仓单",
        },
        component: (resolve) =>
          require(["../views/personalCenter/stashOrigin"], resolve),
      },
      {
        path: "/personalCenter/stashRegister",
        meta: {
          title: "注册仓单",
        },
        component: (resolve) =>
          require(["../views/personalCenter/stashRegister"], resolve),
      },
      {
        path: "/personalCenter/stashOrderDetail",
        meta: {
          title: "仓单详情",
        },
        component: (resolve) =>
          require(["../views/personalCenter/stashOrderDetail"], resolve),
      },
      {
        path: "/personalCenter/settlementRecords",
        meta: {
          title: "交收记录",
        },
        component: (resolve) =>
          require(["../views/personalCenter/settlementRecords"], resolve),
      },
      {
        path: "/personalCenter/settlementDetail",
        meta: {
          title: "交收记录详情",
        },
        component: (resolve) =>
          require(["../views/personalCenter/settlementDetail"], resolve),
      },
      {
        path: "/personalCenter/stashCheckRecords",
        meta: {
          title: "仓单审核记录",
        },
        component: (resolve) =>
          require(["../views/personalCenter/stashCheckRecords"], resolve),
      },
      {
        path: "/publishNew",
        meta: {
          title: "发布交易",
        },
        component: (resolve) =>
          require(["../views/publish/publishNew"], resolve),
      },
      {
        path: "/stashPublish",
        meta: {
          title: "发布仓单交易",
        },
        component: (resolve) =>
          require(["../views/publish/stashPublish"], resolve),
      },
      {
        path: "/goodsPublish",
        meta: {
          title: "发布现货交易",
        },
        component: (resolve) =>
          require(["../views/publish/goodsPublish"], resolve),
      },
      {
        path: "/overseasPublish",
        meta: {
          title: "发布海外交易",
        },
        component: (resolve) =>
          require(["../views/publish/overseasPublish"], resolve),
      },

      {
        path: "/baseInfo",
        meta: {
          title: "个人信息",
        },
        component: (resolve) =>
          require(["../views/baseInfo/baseInfo"], resolve),
      },
      {
        path: "/personalCenter/declaration",
        meta: {
          title: "报关单",
        },
        component: (resolve) =>
          require(["../views/personalCenter/declaration"], resolve),
      },
      {
        path: "/personalCenter/accountLink",
        meta: {
          title: "账号关联",
        },
        component: (resolve) =>
          require(["../views/personalCenter/accountLink"], resolve),
      },
      {
        path: "/personalCenter/invoiceEnter",
        meta: {
          title: "发票助手",
        },
        component: (resolve) =>
          require(["../views/personalCenter/invoiceEnter"], resolve),
      },
      {
        path: "/personalCenter/invoiceList",
        meta: {
          title: "开票记录",
        },
        component: (resolve) =>
          require(["../views/personalCenter/invoiceList"], resolve),
      },
      {
        path: "/personalCenter/attentionList",
        meta: {
          title: "我关注的交易",
        },
        component: (resolve) =>
          require(["../views/personalCenter/attentionList"], resolve),
      },
      {
        path: "/personalCenter/overseas/account",
        meta: {
          title: "账号管理",
        },
        component: (resolve) =>
          require(["../views/personalCenter/overseas/account"], resolve),
      },
      {
        path: "/personalCenter/overseas/authentication",
        meta: {
          title: "认证信息",
        },
        component: (resolve) =>
          require(["../views/personalCenter/overseas/authentication"], resolve),
      },
      {
        path: "/personalCenter/overseas/goods",
        meta: {
          title: "我的货源",
        },
        component: (resolve) =>
          require(["../views/personalCenter/overseas/goods"], resolve),
      },
      {
        path: "/personalCenter/agencySource",
        meta: {
          title: "代理货源",
        },
        component: (resolve) =>
          require(["../views/personalCenter/agencySource"], resolve),
      },

      {
        path: "/personalCenter/afterSales",
        meta: {
          title: "售后列表",
        },
        component: (resolve) =>
          require(["../views/personalCenter/afterSales"], resolve),
      },
      {
        path: "/personalCenter/wihtelistMenu",
        meta: {
          title: "客户管理",
        },
        component: (resolve) =>
          require(["../views/personalCenter/wihtelistMenu"], resolve),
      },
      {
        path: "/personalCenter/afterSalesDetail",
        meta: {
          title: "售后详情",
        },
        component: (resolve) =>
          require(["../views/personalCenter/afterSalesDetail"], resolve),
      },
      {
        path: "/ultraLowTunaPublish",
        meta: {
          title: "发布超低温金枪鱼交易",
        },
        component: (resolve) =>
          require(["../views/publish/ultraLowTunaPublish"], resolve),
      },
    ],
  },

  {
    path: "/rank",
    meta: {
      title: "排行榜",
    },
    component: (resolve) => require(["../views/rank/rank"], resolve),
  },

  {
    path: "/userAuth",
    meta: {
      title: "认证",
    },
    component: (resolve) => require(["../views/userAuth/userAuth"], resolve),
  },

  {
    path: "/regRecord",
    meta: {
      title: "报名记录",
    },
    component: (resolve) => require(["../views/regRecord/regRecord"], resolve),
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/userCenter.js